import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import {eventBus} from './services/eventBus';
import utils from './services/utils';
import {timeFrames} from "./services/staticData";
import {ENUMS} from "./services/enums";
import LocalStorage from "./services/localStorage";
import ModalsStore from './store/modals.store';
import EventsStore from "./store/events.store";
import PipelineStore from "./store/pipeline.store";
import CampaignsStore from "./store/campaigns.store";
// import {useCampaignStore} from "./modules/campaigns/campaigns.store";
import CommsStore from "./store/comms.store";
import StatsStore from "./store/stats.store";
import UpNextStore from "./store/up-next.store";
import InboxStore from "./store/inbox.store";
import ContactingStateStore from "./store/contactingState.store";
import ActiveStateStore from "./store/activeState.store";
import FollowUpStateStore from "./store/followUpState.store";
import CompletedStateStore from "./store/completedState.store";
import DeadStateStore from "./store/deadState.store";
import NonLeadStateStore from "./store/nonLeadState.store";
import RegistrationStore from "./store/registration.store";
import ActiveInboxLeadItemStore from "./store/activeInboxLeadItem.store";
import ActiveInboxInboundCommItemStore from "./store/activeInboxInboundCommItem.store";
import ActivePipelineViewStore from "./store/pipelineViews.store";
import ActiveFollowUpStateItemStore from "./store/activeFollowUpStateItem.store";
import ActiveTextRecordModalStore from "./store/activeTextRecordModal.store";
import ActiveTextContactModalStore from "./store/activeTextContactModal.store";
import RecordsInManualFollowUpStore from "./store/recordsInManualFollowUp.store";
import RecordsInAutomatedFollowUpStore from "./store/recordsInAutomatedFollowUp.store";
import DashboardStore from "./store/dashboard.store";
import DashboardContactingStore from "./store/dashboardContacting.store";
import DashboardFollowUpStore from "./store/dashboardFollowUp.store";
import DashboardActiveStore from "./store/dashboardActive.store";
import DashboardAppointments from "./store/dashboardAppointments.store";
import DashboardTasks from "./store/dashboardTasks.store";
import dates from "./services/dates";
import api from "./api";
import {MODELS} from "./services/models";
import store from "./store"
import StatsKpiStore from "./store/stats-kpi.store";
import StatsTeamStore from "./store/statsTeam.store";
import leadsStore from "./store/leads.store";
import contactsStore from "./store/contacts.store";
import PauseNotificationModal from "./modules/auth/components/PauseNotificationModal.vue";
import {appendModal} from "./services/modals";
import {DateTime} from "luxon";
import OnboardingStore from "./store/onboarding.store";
import localStorageService from "./services/localStorage";
import AccountStore from "./store/account.store";

Vue.use(Vuex);

/*
 * Before adding to this global store make sure you check
 * if a module store exists first!!!!!
 */

const isDev = process.env.NODE_ENV !== 'production';

const set = key => (state, data) => {
  state[key] = data;
};

const push = key => (state, data) => {
  // insert new item doesn't exist add it to the array
  if (!state[key].find(item => item.id === data.id)) {
    state[key].push(data)
  }
};

const unshift = key => (state, data) => {
  state[key].unshift(data);
};

const updateOne = key => (state, data) => {
  state[key] = state[key].map(item => (item.id === data.id) ? {...item, ...data} : item);
};

const updateRoot = key => (state, data) => {
  state[key] = {...state[key], ...data};
};

const removeOne = key => (state, data) => {
  state[key] = state[key].filter(item => item.id !== data.id);
};

const updateProp = (key, key2, key3) => (state, data) => {
  if (key3) {
    for (let prop in data) {
      state[key][key2][key3][prop] = data[prop];
    }
  } else if (key2) {
    for (let prop in data) {
      state[key][key2][prop] = data[prop];
    }
  } else {
    for (let prop in data) {
      state[key][prop] = data[prop];
    }
  }
};


function isEntityCollection(state, payload) {
  if (state[payload.store] && state[payload.store][payload.prop]) {
    return (state[payload.store][payload.prop].items && state[payload.store][payload.prop].order);
  }

  return false;
}

const state = {
  sessionTimeout:null,
  continueSessionModal: undefined,
  reiRealEstateOptionsOpen: false,
  initData: null,
  activeRecord: null,
  activeContact: null,
  account: {
    account: null,
  },
  market: null,
  user: null,
  // comms: { comms: [] },
  enums: null,
  appIsInitiated: false,
  isShortPipeline: false,
  isMobile: false,
  // isTablet: false,
  isLoggedIn: false,
  recordFilters: {
    users: [],
    campaigns: 0,
    exitStrategies: 0,
    temperatures: null,
    timeFrames: 0,
    deals: 0,
  },
  webhooks: [],
  activeUser: null, // TODO:  Not reactive and needs to be removed
  activities: [],
  imports: [],
  // incompleteScheduledContacts: [],
  importsValidationErrors: [],
  // recordScheduledContacts: [],
  // selectedPipelineViewId: 0,
  // profileModalOpenedTabs: [],
};

const mutations = {
  setMarket: set('market'),
  setUser: set('user'),
  setAccount: set('account'),
  setActiveRecord: set('activeRecord'),
  setActiveContact: set('activeContact'),
  setEnums: set('enums'),
  setInitData: set('initData'),
  setRealEstateOptionsOpen: (state, isOpen) => {
    state.reiRealEstateOptionsOpen = isOpen;
  },

  // setRecordScheduledContacts: set('recordScheduledContacts'),
  // pushRecordScheduledContacts: push('recordScheduledContacts'),
  // removeRecordScheduledContacts: removeOne('recordScheduledContacts'),
  // updateRecordScheduledContacts: updateOne('recordScheduledContacts'),

  updateInCollection(state, payload) {
    if (state[payload.store] && state[payload.store][payload.prop]) {
      // Better way of adding
      if (isEntityCollection(state, payload)) {
        state[payload.store][payload.prop].update(payload.data);
      }
      // Less efficient way of adding by cloning the entire array.
      else {
        // If there is no collection the store item no longer exists, so we do nothing
        // This could be due to the store being torn down
        if (state[payload.store][payload.prop]) {
          const isArray = Array.isArray(state[payload.store][payload.prop]);

          // This is the standard way of updating an array
          if(isArray) {
            state[payload.store][payload.prop] = state[payload.store][payload.prop].map(item => item.id === payload.data.id ? {...item, ...payload.data} : item);
          }
          // This is the way to update when getting pagination object
          else {
            state[payload.store][payload.prop].data = state[payload.store][payload.prop].data.map(item => item.id === payload.data.id ? {...item, ...payload.data} : item);
          }
        }
      }
    }
  },
  addToCollection(state, payload) {
    if (state[payload.store] && state[payload.store][payload.prop]) {
      // Better way of adding
      if (isEntityCollection(state, payload)) {
        state[payload.store][payload.prop].add(payload.data);
      }
      // Less efficient way of adding by cloning the entire array.
      else {
        // If there is no collection the store item no longer exists, so we do nothing
        // This could be due to the store being torn down
        if (state[payload.store][payload.prop]) {
          if (!state[payload.store][payload.prop].some(item => item.id === payload.data.id)) {
            state[payload.store][payload.prop].push(payload.data);
          }
        }
      }
    }
  },
  upsertCollection(state, payload) {
    if (state[payload.store] && state[payload.store][payload.prop]) {
      // Better way of upserting
      if (isEntityCollection(state, payload)) {
        state[payload.store][payload.prop].upsert(payload.data);
      }
      // Less efficient way of upserting by cloning the entire array.
      else {
        // If there is no collection the store item no longer exists, so we do nothing
        // This could be due to the store being torn down
        if (state[payload.store][payload.prop]) {
          const isArray = Array.isArray(state[payload.store][payload.prop]);

          // This is the standard way of updating an array
          if(isArray) {
            // If new item doesn't exist add it to the array;
            if (!state[payload.store][payload.prop].some(item => item.id === payload.data.id)) {
              state[payload.store][payload.prop].push(payload.data);
            }
            // If the item does exist
            else {
              state[payload.store][payload.prop] = state[payload.store][payload.prop].map(item => item.id === payload.data.id ? {...item, ...payload.data} : item);
            }
          }
          // This is the way to update when getting pagination object
          else {
            // If new item doesn't exist add it to the array;
            if (!state[payload.store][payload.prop].data.some(item => item.id === payload.data.id)) {
              state[payload.store][payload.prop].data.push(payload.data);
            }
            // If the item does exist
            else {
              state[payload.store][payload.prop].data = state[payload.store][payload.prop].data.map(item => item.id === payload.data.id ? {...item, ...payload.data} : item);
            }
          }

        }
      }
    }
  },
  removeFromCollection(state, payload) {
    if (state[payload.store] && state[payload.store][payload.prop]) {
      // Better way of removing
      if (isEntityCollection(state, payload)) {
        state[payload.store][payload.prop].remove(payload.data);
      }
      // Less efficient way of removing by cloning the entire array.
      else {
        // If there is no collection the store item no longer exists, so we do nothing
        // This could be due to the store being torn down
        if(state[payload.store][payload.prop]) {
          const isArray = Array.isArray(state[payload.store][payload.prop]);
          // This is the standard way of updating an array
          if (isArray) {
            state[payload.store][payload.prop] = state[payload.store][payload.prop].filter(item => item.id !== payload.data.id);
          }
          // This is the way to update when getting pagination object
          else {
            state[payload.store][payload.prop].data = state[payload.store][payload.prop].data.filter(item => item.id !== payload.data.id);
          }
        }
      }
    }
  },
  setRoot(state, payload) {
    if (state[payload.store] && state[payload.store][payload.prop] !== undefined) {
      state[payload.store][payload.prop] = payload.data;
    }
  },
  updateRoot(state, payload) {
    if (state[payload.store] && state[payload.store][payload.prop]) {
      state[payload.store][payload.prop] = {...state[payload.store][payload.prop], ...payload.data};
    }
  },

  setAppIsInitiated: set('appIsInitiated'),
  setIsLoggedIn: set('isLoggedIn'),
  setIsShortPipeline: set('isShortPipeline'),
  setIsMobile: set('isMobile'),
  setIsTablet: set('isTablet'),
  // setSelectedPipelineViewId: set('selectedPipelineViewId'),

  setActiveRecordProp(state, data) {
    state.activeRecord[data.prop] = data.value;
  },

  setActiveContactProp(state, [prop, value]) {
    state.activeContact[prop] = value;
  },

  setWebhooks: set('webhooks'),
  pushWebhooks: push('webhooks'),
  removeWebhook: removeOne('webhooks'),
  updateWebhook: updateOne('webhooks'),
  updateWebhookProp(state, data) {
    const hook = state.webhooks.find(hook => hook.id === data.id);
    for (let prop in data) {
      hook[prop] = data[prop];
    }
  },
  unshiftWebhookSubmission(state, data) {
    const webhook = state.webhooks.find(hook => hook.id === data.webhook_id);

    if (webhook.submissions) {
      if (webhook.submissions.length > 2) {
        webhook.submissions.pop();
      }
    } else {
      webhook.submissions = [];
    }

    webhook.submissions.unshift(data);
  },
  initWebhookSubmissions(state) {
    state.webhooks.map(hook => hook.submissions = []);
  },

  setActiveUser: set('activeUser'),
  updateActiveUser: updateRoot('activeUser'),

  setActivities: set('activities'),
  pushActivities: push('activities'),
  removeActivity: removeOne('activities'),

  setImports: set('imports'),
  pushImports: push('imports'),
  removeImport: removeOne('imports'),
  updateImport: updateOne('imports'),

  pushImportsValidationErrors: push('importsValidationErrors'),
  updateImportsValidationErrors: updateOne('importsValidationErrors'),

  clearMetadata(state) {
    state.importsValidationErrors = [];
    state.webhookFieldmaps = [];
  },

  // pushProfileModalOpenedTabs: push('profileModalOpenedTabs'),
  // clearProfileModalOpenedTabs(state) {
  //   state.profileModalOpenedTabs = [];
  // }
  setUserAppFilters(state, data) {
    if(!data) return;

    if(data.length === 0) return;

    Object.entries(data).forEach(([storeModule, filters]) => {
      store.commit(`${storeModule}/setUserFilters`, filters)
    });
  },

  setSessionTimeout: (state, plusHours) => {
    state.sessionTimeout = DateTime.now().plus({hours: plusHours});
  },
  clearSessionTimeout: (state) => {
    state.sessionTimeout = null;
  },
};

const actions = {
  apiCallMade({commit}) {
    if (LocalStorage.getAuthUser()) {
      commit('setSessionTimeout', process.env.MIX_SESSION_TIMEOUT_IN_HOURS)
    } else {
      commit('clearSessionTimeout')
    }
  },
  pusherEvent({state, commit, getters}, payload) {
    let authUser = localStorageService.getAuthUser();
    if (payload.store === 'account' && payload.prop === 'account') {
      if (payload.data.status === ENUMS.AccountStatusEnum.Paused.value) {
        appendModal(PauseNotificationModal)
        return;
      }
    }

    if (payload.store === 'activeRecord' || payload.store === 'record') {
      // This is here to make sure we ignore events for active records that do not match the current active record the user is looking at
      if (!state.activeRecord || state.activeRecord.record.id !== parseInt(payload.channel.split('.')[1])) {
        return;
      }
    }

    if (payload.store === 'market' && payload.prop === 'inboxLeadsItemLite') {
      // This is here to make sure we ignore events for leads that do not have the users assigned if they dont have the view all leads permission
      if (authUser && authUser.can_access_all_leads === false) {
        if (payload.data.users.filter(user => user.id === authUser.id).length === 0) {
          return;
        }
      }
    }

    if (payload.store === 'account' && payload.prop === 'tableConfigurations' && payload.prop.method !== 'removeFromCollection') {
      // this is here to ignore events if its private data and user don't match the current auth user
      if (payload.data.user_id && authUser && authUser.id !== payload.data.user_id) {
        return
      }
    }

    if (payload.store === 'user') {
      // This is here to make sure we ignore events for users that do not match the current active record the user is looking at
      if (!state.activeUser || state.activeUser.id !== parseInt(payload.channel.split('.')[1])) {
        return;
      }

      // Need to play notification sound if notificationsCount increases
      const currentCount = state.user.badges.notificationsCount
      const newCount = payload.data.notificationsCount

      if(newCount > currentCount) {
        utils.playNotificationSound(getters.authUser.notification_sound)
      }
    }

    if (payload.store === '' && payload.prop === '') {
      setTimeout(() => {
        let storeAction = ''

        // if (payload.data.class_name === MODELS.Task.class_name) storeAction = "dashboardTasks/processPusherEvent"
        if (payload.data.class_name === MODELS.Appointment.class_name) storeAction = "dashboardAppointments/processPusherEvent"

        if (storeAction !== '') {
          store.dispatch(storeAction, payload).then(res => {})
        }
      }, payload.delay)
      return
    }

    // verifies that the store exists
    if (!state[payload.store]) return;

    setTimeout(() => {
      if (payload.data) {
        commit(payload.method, payload);
        eventBus.$emit(`${payload.store}.${payload.prop}.${payload.method}`, payload.data);
      } else {
        api.pusher.getPayload(payload.api_call).then(res => {
          payload.data = res.data;
          commit(payload.method, payload);
        }, error => {
          if (error.response && error.response.status === 404) {
            if (payload.method === ENUMS.PusherServiceMethodEnum.UpdateInCollection) {
              commit(ENUMS.PusherServiceMethodEnum.RemoveFromCollection.value, payload)
            }
            if (payload.method === ENUMS.PusherServiceMethodEnum.UpsertCollection) {
              commit(ENUMS.PusherServiceMethodEnum.RemoveFromCollection.value, payload)
            }
            if (payload.method === ENUMS.PusherServiceMethodEnum.AddToCollection) {
              commit(ENUMS.PusherServiceMethodEnum.RemoveFromCollection.value, payload)
            }
            if (payload.method === ENUMS.PusherServiceMethodEnum.RemoveFromCollection) {
              // Should never actually be called
              commit(ENUMS.PusherServiceMethodEnum.RemoveFromCollection.value, payload)
            }
            if (payload.method === ENUMS.PusherServiceMethodEnum.SetRoot) {
              // Ignore this, example the lead modal, will not update.
            }
            if (payload.method === ENUMS.PusherServiceMethodEnum.PatchRoot) {
              // Ignore this, example the lead modal, will not update.
            }
          }
        });
      }
    }, payload.delay);
  },
  updateUserAppFilter({state, getters, commit}) {
    api.users.updateFilterData(getters.authUser.id, getters.userAppFilters)
      .then((res) => {
        commit('setUserAppFilters', res.data.data.filters)
      })
  },
};

const getters = {
  timezones(state) {
    return state.initData.timezones;
  },
  billingPlan(state) {
    return state.account.account.billingPlan;
  },
  account(state) {
    return state.account.account;
  },
  pipelineViews(state) {
    return state.account.pipelineViews;
  },
  statusesWithTrashed(state) {
    return [...state.account.statuses].sort((a, b) => a.order - b.order);
  },
  statuses(state, getters) {
    return state.account.statuses
    // return getters.statuses.filter(status => status.deleted_at !== null);
  },
  selectedPipelineView(state, getters, rootState, rootGetters) {
    return rootGetters["activePipelineView/activePipelineView"];
  },
  users(state) {
    let users = state.account.users;
    return users.sort((a, b) => (a.first_name > b.first_name) ? 1 : -1);
  },
  userById: (state, getters) => (userId) => {
    return getters.users.find(user => user.id === userId);
  },
  authUser(state) {
    return state.account.users.find(u => u.id === LocalStorage.getAuthUser().id);
  },
  activeUsers(state, getters) {
    let users = state.account.users.filter(u => {
      return u.deleted_at === null && u.type === ENUMS.UserTypeEnum.Account.value;
    });
    return users.sort((a, b) => (a.first_name > b.first_name) ? 1 : -1);
  },
  thirdPartyUsers(state, getters) {
    let users = state.account.users.filter(u => {
      return u.deleted_at === null && u.type !== ENUMS.UserTypeEnum.Account.value;
    });
    return users.sort((a, b) => (a.first_name > b.first_name) ? 1 : -1);
  },
  customFields: (state, getters) => (customFieldableType, customFieldableId) => {
    const fields = getters.customFieldsWithTrashed.filter(c => {
      // if trashed don't return field
      if (c.deleted_at !== null) {
        return false;
      }

      // check if there is an id and if so only return those fields
      if (customFieldableId && c.custom_fieldable_id === customFieldableId) {
        return true;
      }
      // if no id but type then return all of that type
      else if (!customFieldableId && customFieldableType && c.custom_fieldable_type === customFieldableType) {
        return true;
      }
      // if nothing matches then return nothing
      else {
        return false;
      }
    });
    return fields.sort((a, b) => a.order - b.order);
  },
  customFieldsWithTrashed(state) {
    return [...state.account.customFields].sort((a, b) => a.order - b.order);
  },
  recordCustomFieldsWithTrashed(state, getters) {
    return getters.customFieldsWithTrashed.filter(customField => customField.custom_fieldable_type === ENUMS.CustomFieldableTypeEnum.Record.value);
  },
  recordCustomFields(state, getters) {
    return getters.recordCustomFieldsWithTrashed.filter(customField => customField.deleted_at === null);
  },
  contactCustomFieldsWithTrashed(state, getters) {
    return getters.customFieldsWithTrashed.filter(customField => customField.custom_fieldable_type === ENUMS.CustomFieldableTypeEnum.Contact.value);
  },
  contactCustomFields(state, getters) {
    return getters.contactCustomFieldsWithTrashed.filter(customField => customField.deleted_at === null);
  },
  defaultAppointmentReminder(state, getters) {
    return {
      send_user_reminders: (getters.authUser.time_before_text_appointment_reminder !== null || getters.authUser.time_before_email_appointment_reminder !== null),
      user_text_reminder: getters.account.user_text_reminder,
      user_email_reminder: getters.account.user_email_reminder,
      send_contact_reminders: (getters.account.send_contact_text_reminder || getters.account.send_contact_email_reminder),
      time_before_contact_reminders: getters.account.time_before_contact_reminders,
      send_contact_text_reminder: getters.account.send_contact_text_reminder,
      contact_text_reminder: getters.account.contact_text_reminder,
      send_contact_email_reminder: getters.account.send_contact_email_reminder,
      contact_email_reminder: getters.account.contact_email_reminder
    };
  },
  snippets(state) {
    return state.account.snippets;
  },
  fusTemplatesWithTrashed(state) {
    const templates = state.account.fusTemplates;
    return templates.sort((a, b) => (a.label > b.label) ? 1 : -1)
  },
  fusTemplateById: (state, getters) => (id) => {
    return getters.fusTemplatesWithTrashed.find(t => t.id === id);
  },
  callScripts(state) {
    return state.account.callScripts;
  },
  fusTemplates(state, getters) {
    const templates = getters.fusTemplatesWithTrashed.filter(t => !t.deleted_at);
    return templates.sort((a, b) => (a.label > b.label) ? 1 : -1)
  },
  market(state) {
    return state.market.market;
  },
  pipeline(state) {
    return state.market.pipeline;
  },
  pipelineRecords: (state, getters) => (statusIds) => {
    let records;

    if (statusIds) {
      records = getters.pipeline.filter(record => {
        return statusIds.includes(record.active_status.status_id);
      });
    } else {
      records = getters.pipeline;
    }

    let sortedRecords = records.filter(record => {
      const assignedUsers = utils.getAssignedUsers(record);

      if (state.recordFilters.users.length === 0) {
        return true;
      }

      if (state.recordFilters.users.includes(0)
        && record.users.length === 0
        && assignedUsers.length === 0
      ) {
        return true;
      }

      return (record.users.some(u => state.recordFilters.users.includes(u.id)) || assignedUsers.some(u => state.recordFilters.users.includes(u)));
    })
      .filter(record => {
        if (state.recordFilters.campaigns === 0) {
          return true;
        }

        if (state.recordFilters.campaigns === -1) {
          if (record.campaign_id === null) {
            return true;
          }
        }

        if (state.recordFilters.campaigns === -2) {
          if (record.campaign_id) {
            return true;
          }
        }

        if (record.campaign_id) {
          return record.campaign_id === state.recordFilters.campaigns;
        }

        return false;
      })
      .filter(record => {
        // Leads & Deals
        if (state.recordFilters.deals === 0) {
          return true;
        }

        // Leads
        if (state.recordFilters.deals === 1) {
          return record.deal_at === null;
        }

        // Deals
        if (state.recordFilters.deals === 2) {
          return record.deal_at;
        }

        return false;
      })
      .filter(record => {
        if (state.recordFilters.exitStrategies === 0) {
          return true;
        }

        if (record.exit_strategy) {
          return record.exit_strategy === state.recordFilters.exitStrategies;
        }

        return false;
      })
      .filter(record => {
        if (state.recordFilters.temperatures === '') {
          return true;
        }

        if (record.temperature !== '') {
          return record.temperature === state.recordFilters.temperatures;
        }

        return false;
      })
      .filter(record => {
        if (!state.recordFilters || state.recordFilters.timeFrames === 0) {
          return true;
        }

        const modifiedAt = dates.getISO(record.updated_at);
        const time = timeFrames.find(t => t.value === state.recordFilters.timeFrames);

        if (time) {
          return dates.isAfter(modifiedAt, time.start) && dates.isBefore(modifiedAt, time.end);
        }

        return false;
      });

    return sortedRecords.sort((a, b) => {
      a = new Date(a.active_status.due_at);
      b = new Date(b.active_status.due_at);
      return b > a ? -1 : b < a ? 1 : 0;
    });
  },
  tasksBadge(state) {
    // const incompleteTasks = state.upNext.incompleteTasks;
    const incompleteTasks = state.market.incompleteTasks;

    const pastDueTasks = incompleteTasks.filter(task => {
      return dates.isInPast(task.due_at);
    });

    return pastDueTasks.length;
  },
  inboxBadge(state, getters) {
    return getters["inbox/itemsCount"];
  },
  pipelineAppointments(state) {
    return state.market.pendingAppointments;
  },
  pipelineIncompleteTasks(state) {
    return state.market.incompleteTasks;
  },
  dealsCountThisMonth(state) {
    return state.market.dealsCountThisMonth.total;
  },
  notificationsCount(state) {
    return state.user.badges.notificationsCount;
  },
  mentionsCount(state) {
    return state.user.badges.mentionsCount;
  },
  errorsCount(state) {
    return state.user.badges.errorsCount;
  },
  contact(state) {
    return state.activeRecord.contact;
  },
  property(state) {
    return state.activeRecord.property;
  },
  campaigns(state) {
    let campaigns = utils.clone(state.market.campaigns);
    return campaigns.map((campaign) => {
      campaign.integrationPhoneNumber = state.market.integrationPhoneNumbers.find(n => n.campaign_id === campaign.id);
      return campaign;
    }).sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);
  },
  activeCampaigns(state, getters) {
    return getters.campaigns.filter(c => c.deleted_at === null);
  },
  integrations(state) {
    return state.market.integrations;
  },
  hasLaunchControlIntegration(state, getters) {
    const integrations = getters.integrations.filter(integration => {
      return integration.type === ENUMS.IntegrationTypeEnum.LaunchControl.value;
    });

    return !!integrations.length;
  },
  hasCallRailIntegration(state, getters) {
    const integrations = getters.integrations.filter(integration => {
      return integration.type === ENUMS.IntegrationTypeEnum.CallRail.value
    });

    return !!integrations.length;
  },
  hasGoogleCalendarIntegration(state, getters) {
    const integrations = getters.integrations.filter(integration => {
      return integration.type === ENUMS.IntegrationTypeEnum.GoogleCalendar.value;
    });

    return !!integrations.length;
  },
  hasSmrtPhoneIntegration(state, getters) {
    const integrations = getters.integrations.filter(integration => {
      return integration.type === ENUMS.IntegrationTypeEnum.SmrtPhone.value
    });

    return !!integrations.length;
  },
  hasPhoneIntegration(state, getters) {
    const phoneIntegrations = getters.integrations.filter(integration => {
      return integration.type === ENUMS.IntegrationTypeEnum.CallRail.value
        || integration.type === ENUMS.IntegrationTypeEnum.SmrtPhone.value;
    });

    return !!phoneIntegrations.length;
  },
  smrtPhoneIntegration(state, getters) {
    return getters.integrations.find(integration => integration.type === ENUMS.IntegrationTypeEnum.SmrtPhone.value);
  },
  isSmrtPhoneIntegrationComplete(state, getters) {
    if (getters.hasSmrtPhoneIntegration) {
        return !!(getters.smrtPhoneIntegration.token && getters.smrtPhoneIntegration.token.auth_token);
    }

    return false;
  },
  launchControlIntegration(state, getters) {
    return getters.integrations.find(integration => integration.type === ENUMS.IntegrationTypeEnum.LaunchControl.value)
  },
  callRailIntegration(state, getters) {
    return getters.integrations.find(integration => integration.type === ENUMS.IntegrationTypeEnum.CallRail.value);
  },
  partnerCallRailIntegration(state, getters) {
    return getters.integrations.find(integration => integration.type === ENUMS.IntegrationTypeEnum.PartnerPortalCallRail.value);
  },
  integrationPhoneNumbers(state) {
    let numbers = state.market.integrationPhoneNumbers;
    return numbers.sort((a, b) => (a.label > b.label) ? 1 : -1)
  },
  googleCalendarIntegration(state, getters) {
    return getters.integrations.find(i => i.type === 3);
  },
  gmailIntegrations(state, getters) {
    return getters.integrations.filter(i => i.type === ENUMS.IntegrationTypeEnum.Gmail.value);
  },
  gmailCompleteIntegrations(state, getters) {
    return getters.gmailIntegrations.filter(i => {
      return !!(i.token && i.token.access_token && i.data && i.data.email_address && i.data.verified_at);
    });
  },
  gmailIsIntegrated(state, getters) {
    if (getters.market.email_integration_type === ENUMS.EmailIntegrationTypeEnum.Gmail.value) {
      if (getters.gmailIntegrations.length === 0) return false;

      return !!getters.gmailCompleteIntegrations.length;
    }

    return false;
  },
  gmailActiveUsers(state, getters) {
    return getters.activeUsers.filter(user => {
      const integration = getters.gmailCompleteIntegrations.find(i => i.user_id === user.id);

      if (integration) {
        user.outgoing_email_address = integration.data.email_address;
        return user;
      }
    });
  },
  mailgunDomainData(state, getters) {
    return getters.account.email_domain_data;
  },
  mailgunIntegrations(state, getters) {
    return getters.integrations.filter(i => i.type === ENUMS.IntegrationTypeEnum.MailGun.value);
  },
  mailgunCompleteIntegrations(state, getters) {
    return getters.mailgunIntegrations.filter(i => {
      return (i.data && i.data.outgoing_email_name && i.data.verified_at);
    });
  },
  mailgunDnsIsVerified(state, getters) {
    if (!getters.mailgunDomainData) return false;

    const dnsCount = getters.mailgunDomainData.sending_dns_records.length;
    const validDnsCount = getters.mailgunDomainData.sending_dns_records.filter(dns => {
      return dns.valid === 'valid';
    }).length;

    return dnsCount === validDnsCount;
  },
  mailgunIsIntegrated(state, getters) {
    if (getters.market.email_integration_type === ENUMS.EmailIntegrationTypeEnum.MailGun.value) {
      if (getters.mailgunIntegrations.length === 0) return false;

      return getters.mailgunDnsIsVerified && !!getters.mailgunCompleteIntegrations.length;
    }

    return false;
  },
  mailgunActiveUsers(state, getters) {
    return getters.activeUsers.filter(user => {
      const integration = getters.mailgunCompleteIntegrations.find(i => i.user_id === user.id);

      if (integration) {
        user.outgoing_email_address = `${integration.data.outgoing_email_name}@${getters.account.email_domain}`;
        return user;
      }
    });
  },
  emailIsIntegrated(state, getters) {
    return getters.gmailIsIntegrated || getters.mailgunIsIntegrated;
  },
  googleCalendarIsIntegrated(state, getters) {
    if (getters.googleCalendarIntegration) {
      return (getters.googleCalendarIntegration.token
        && getters.googleCalendarIntegration.token.access_token
        && getters.googleCalendarIntegration.data
        && getters.googleCalendarIntegration.data.calendar_label
      );
    }

    return false;
  },
  googleCalendarIntegrationError(state, getters) {
    if (getters.googleCalendarIntegration && !getters.googleCalendarIsIntegrated) {
      return (getters.googleCalendarIntegration.token && getters.googleCalendarIntegration.token.error);
    }

    return false;
  },
  maxRecordsPerFusTemplate() {
    return process.env.MIX_FOLLOW_UP_SEQUENCE_MAX_RECORDS_PER_TEMPLATES;
  },
  maxStepsPerFusTemplate() {
    return process.env.MIX_FOLLOW_UP_SEQUENCE_MAX_STEPS_PER_TEMPLATE;
  },
  contactTags(state) {
    let tags = utils.clone(state.market.tags.filter(tag => {
      return tag.taggable_type === ENUMS.TaggableTypeEnum.Contact.value
    }));
    return tags.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);
  },
  contactTypes(state) {
    let types = utils.clone(state.market.contactTypes);
    return types.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1);
  },
  taskTags(state) {
    let tags = utils.clone(state.market.tags.filter(tag => {
      return tag.taggable_type === ENUMS.TaggableTypeEnum.Task.value
    }));
    return tags.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);
  },
  // kpisFilters(state, getters) {
  //   let kpisFilter = utils.clone(state.kpisFilters);
  //   kpisFilter.campaigns = state.kpisFilters.campaigns.filter(campaignId => {
  //     if (campaignId === null) return true
  //
  //     return getters.activeCampaigns.find(activeCampaign => activeCampaign.id === campaignId);
  //   })
  //
  //   return kpisFilter;
  // },
  // funnelFilters(state, getters) {
  //   let funnelFilter = utils.clone(state.funnelFilters);
  //   funnelFilter.campaigns =  state.funnelFilters.campaigns.filter(campaignId => {
  //     if (campaignId === null) return true
  //
  //     return getters.activeCampaigns.find(activeCampaign => activeCampaign.id === campaignId);
  //   })
  //
  //   return funnelFilter;
  // },
  importsValidationErrors(state, getters) {
    return state.importsValidationErrors;
  },
  onboardingProgress(state) {
    const account = state.account.account;
    const onboardingSteps = account.onboardingSteps;
    let totalCount = 0;
    let trueCount = 0;

    if (onboardingSteps) {
      for (let [key, value] of Object.entries(onboardingSteps)) {
        if (value) {
          trueCount++;
        }

        totalCount++;
      }
    }

    // If the account doesn't have integration services
    // then remove one count because integration step shouldn't count
    if (
      !account.has_calendar_integration_feature ||
      !account.has_email_integration_feature ||
      !account.has_phone_integration_feature
    ) {
      totalCount--;
      trueCount--;
    }

    // If the account doesn't have email and phone integration services
    // then remove one count because follow up step shouldn't count
    if (
      !account.has_email_integration_feature ||
      !account.has_phone_integration_feature
    ) {
      totalCount--;
      trueCount--;
    }

    // this is here to avoid returning NaN value
    if (totalCount === 0) return 0;

    return Math.trunc(trueCount / totalCount * 100);
  },
  userAppFilters(state) {
    return {
      campaigns: state.campaigns.filters,
      comms: state.comms.filters,
      inbox: state.inbox.filters,
      activePipelineView: state.activePipelineView.filters,
      activeState: state.activeState.filters,
      contactingState: state.contactingState.filters,
      followUpState: state.followUpState.filters,
      completedState: state.completedState.filters,
      deadState: state.deadState.filters,
      nonLeadState: state.nonLeadState.filters,
      stats: state.stats.filters,
      statsKpi: state.statsKpi.filters,
      upNext: state.upNext.filters,
    }
  },
  tableConfigurations(state) {
    return state.account.tableConfigurations;
  },
  leadsTableConfigurations(state, getters) {
    return getters.tableConfigurations.filter(table => table.location === ENUMS.TableConfigurationLocationEnum.Record.value)
  },
  contactsTableConfigurations(state, getters) {
    return getters.tableConfigurations.filter(table => table.location === ENUMS.TableConfigurationLocationEnum.Contact.value)
  },
  inboxTableConfigurations(state, getters) {
    return getters.tableConfigurations.filter(table => table.location === ENUMS.TableConfigurationLocationEnum.Inbox.value)
  },
};

const vuexLocal = new VuexPersistence({
  key: 'vuexLocal',
  storage: window.localStorage,
  reducer: (state) => ({
    // campaigns: {
    //   filters: state.campaigns.filters,
    // },
    // comms: {
    //   filters: state.comms.filters,
    // },
    // inbox: {
    //   filters: state.inbox.filters,
    // },
    // activePipelineView: {
    //   activePipelineViewId: state.activePipelineView.activePipelineViewId
    // },
    // activeState: {
    //   filters: state.activeState.filters,
    // },
    // contactingState: {
    //   filters: state.contactingState.filters,
    // },
    // followUpState: {
    //   filters: state.followUpState.filters,
    // },
    // completedState: {
    //   filters: state.completedState.filters,
    // },
    // deadState: {
    //   filters: state.deadState.filters,
    // },
    // nonLeadState: {
    //   filters: state.nonLeadState.filters,
    // },
    // stats: {
    //   filters: state.stats.filters,
    // },
    // statsKpi: {
    //   filters: state.statsKpi.filters,
    // },
    // upNext: {
    //   filters: state.upNext.filters,
    // },
  }),
});

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state,
  mutations,
  actions,
  getters,
  modules: {
    accounts: AccountStore,
    campaigns: CampaignsStore,
    comms: CommsStore,
    events: EventsStore,
    modals: ModalsStore,
    inbox: InboxStore,
    pipeline: PipelineStore,
    activeState: ActiveStateStore,
    contactingState: ContactingStateStore,
    recordsInManualFollowUp: RecordsInManualFollowUpStore,
    recordsInAutomatedFollowUp: RecordsInAutomatedFollowUpStore,
    followUpState: FollowUpStateStore,
    completedState: CompletedStateStore,
    deadState: DeadStateStore,
    nonLeadState: NonLeadStateStore,
    stats: StatsStore,
    statsKpi: StatsKpiStore,
    statsTeam: StatsTeamStore,
    upNext: UpNextStore,
    registration: RegistrationStore,
    activeFollowUpStateItem: ActiveFollowUpStateItemStore,
    activeInboxLeadItem: ActiveInboxLeadItemStore,
    activeInboxInboundCommItem: ActiveInboxInboundCommItemStore,
    activePipelineView: ActivePipelineViewStore,
    activeTextRecordModal: ActiveTextRecordModalStore,
    activeTextContactModal: ActiveTextContactModalStore,
    dashboard: DashboardStore,
    dashboardContacting: DashboardContactingStore,
    dashboardFollowUp: DashboardFollowUpStore,
    dashboardActive: DashboardActiveStore,
    dashboardAppointments: DashboardAppointments,
    dashboardTasks: DashboardTasks,
    onboarding: OnboardingStore,
    leads: leadsStore,
    contacts: contactsStore,
  },
  plugins: [vuexLocal.plugin],
});
